import { utils } from './_utils.js';
import playLottie from "./_playLottie";
var about = function about() {
  var kvAnime = document.getElementById('js-kvAnime');
  var TL = gsap.timeline();
  TL.to(kvAnime, {
    opacity: 1
  }).call(function () {
    return playLottie(kvAnime);
  }, null, '>');
};
export default about;